<ng-container
  [formGroup]="form"
  *ngIf="(form.get(fieldName) || fieldControl) as f; else errore">

  <label *ngIf="fieldLabel" [for]="fieldName" class="form-label">{{ fieldLabel }}</label>

  <input
    *ngIf="!readonlyField; else readonlyInput"
    type="hidden"
    class="form-control"
    [class.is-invalid]="f.errors"
    [class.is-warned]="!!warnings"
    [formControl]="f |toFormControl"
    [value]="f.value"
    [id]="fieldName"
    [attr.placeholder]="placeholder ? placeholder : null">

  <ng-template #readonlyInput>
    <input
      type="hidden"
      [attr.disabled]="true"
      class="form-control"
      [class.is-invalid]="f.errors"
      [class.is-warned]="!!warnings"
      [value]="f.value"
      [formControl]="f | toFormControl"
      [id]="fieldName"
      [attr.placeholder]="placeholder ? placeholder : null">
  </ng-template>

  <div *ngIf="fieldDescription" class="form-text">{{ fieldDescription }}</div>

  <field-warnings [warnings]="warnings"></field-warnings>
  <div field-errors [control]="f"></div>

</ng-container>

<ng-template #errore>
  Il campo <i>{{ fieldName }}</i> non esiste
</ng-template>

